import { Flex, Image } from "@chakra-ui/react"
import Heading from "components/UI/atoms/Heading"
import { ILoundryServicesHeaderProps } from "./LaundryServicesTypes"

const LoundryServicesHeader: React.FC<ILoundryServicesHeaderProps> = ({
  title,
  imageUrl,
}) => {
  return (
    <Flex
      padding={"4px  18px"}
      height={"107px"}
      flex={1}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Flex
        mb={"4px"}
        alignItems={"center"}
        justifyContent={"center"}
        height={"58px"}
        width={"100%"}
        maxWidth={"139px"}
        background={"#E9F2FD"}
        borderRadius={"base"}
      >
        <Image src={imageUrl}/>
      </Flex>
      <Heading variant="regular" size={"sm"} title={title} />
    </Flex>
  )
}

export default LoundryServicesHeader
